import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AdminLayout from "../../layout/adminLayout";
import moment from "moment";
import { environment, apiRoutes } from "../../auth/apiRoute";
import "./style.css";
import Axios from "axios";
import { useCookies } from "react-cookie";
import {
  Table,
  Tag,
  Space,
  message,
  notification,
  Popconfirm,
  Button,
  Divider,
  Input,
  Spin,
  Typography,
} from "antd";
import { CSVLink } from "react-csv";

const hotelNameCollator = new Intl.Collator("en", {
  numeric: true,
  sensitivity: "base",
});

const getHotelName = (record) => {
  if (!record) {
    return "";
  }
  if (record.hotel && record.hotel.name) {
    return record.hotel.name.trim();
  }
  if (record.name) {
    return record.name.trim();
  }
  return "";
};

const compareHotelNames = (a, b) => {
  const aName = getHotelName(a);
  const bName = getHotelName(b);

  if (!aName && !bName) {
    return 0;
  }
  if (!aName) {
    return 1;
  }
  if (!bName) {
    return -1;
  }

  const aStartsWithNumber = /^\d/.test(aName);
  const bStartsWithNumber = /^\d/.test(bName);

  if (aStartsWithNumber !== bStartsWithNumber) {
    return aStartsWithNumber ? -1 : 1;
  }

  return hotelNameCollator.compare(aName, bName);
};

export default function AdminDashboard() {
  const [cookies, setCookie] = useCookies(["haBasAdminDashboard"]);
  // const [cookies, setCookie] = useCookies(["haBasAdminDashboardSort","haBasAdminDashboardFilter","haBasAdminDashboardPage"]);

  const { Text, Paragraph } = Typography;
  const { Search } = Input;
  const [member, setMember] = useState({});
  const [loading, setLoading] = useState(false);
  const [hotels, setHotels] = useState([]);
  const [nominationsData, setNominationsData] = useState([]);
  const [filteredNominationsData, setFilteredNominationsData] = useState([]);
  const [filteredInfo, setFilter] = useState({});
  const [pagination, setPagination] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [searchText, setSearchText] = useState("");
  const [search, setSearch] = useSearchParams();
  useEffect(() => {
    console.log("reload page");
    const savedState = cookies.haBasAdminDashboard || {};
    const savedPagination = savedState.pagination || {};
    const nextPagination = {
      current: savedPagination.current || 1,
      pageSize: savedPagination.pageSize || 10,
      total: savedPagination.total || 0,
    };
    const nextFilters = savedState.filteredInfo || {};
    const nextSorter = savedState.sortedInfo || {};

    setSortedInfo(nextSorter);
    setFilter(nextFilters);
    setPagination(nextPagination);
    getNominations();
    getHotels();
    // getQueryAndSetFilter();
  }, []);

  useEffect(() => {}, [pagination, filteredInfo, sortedInfo]);
  const categories = [
    "Full-Time Hourly With Guest Contact",
    "Full-Time Hourly Without Guest Contact",
    "Full-Time Room Attendant",
    "Managerial Below General Manager",
  ];
  const groupByJudge = (arr) => {
    var result = arr.reduce(function (r, a) {
      a.judge = a.judge || { firstName: "No", lastName: "Judge", _id: 0 };
      if (!r.some((item) => item._id === a.judge._id)) {
        r.push(a.judge);
      }

      return r;
    }, []);
    return result;
  };

  const groupJudge = (arr) => {
    for (const item of arr) {
    }

    var result = arr.reduce(function (r, a) {
      a.judge = a.judge || { firstName: "No", lastName: "Judge", value: 0 };
      r[a.judge.email] = r[a.judge.email] || [];
      r[a.judge.email].push(a);
      return r;
    }, Object.create(null));
    return result;
  };

  const getHotels = async () => {
    try {
      const response = await Axios.post(apiRoutes[environment].hotels);

      if (response.status == 200) {
        var hotelsData = response.data;
        hotelsData = hotelsData.map((item) => {
          return { ...item, ...{ key: item._id } };
        });
        hotelsData.push({
          _id: "00000",
          name: "No Hotel",
        });

        setHotels(hotelsData);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
  };
  const getNominations = async () => {
    setLoading(true);
    console.log("get nominations");
    try {
      const response = await Axios.post(apiRoutes[environment].nominations);

      if (response.status == 200) {
        var nominations = response.data.map((item) => {
          return { ...item, ...{ key: item._id } };
        });
        console.log(nominations.slice(0, 5));
        setNominationsData(nominations);
        setFilteredNominationsData(nominations);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const deleteNomination = async (nominationId) => {
    setLoading(true);
    try {
      const response = await Axios.post(
        apiRoutes[environment].deleteNomination,
        {
          nominationId: nominationId,
        },
      );
      console.log(response.data);
      if (response.status == 200) {
        openNotification();
        getNominations();
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  };
  const openNotification = (message) => {
    notification.success({
      message: `Success!`,
      description: "Your nomination has been successfully deleted! ",
      placement: "top",
    });
  };
  const onChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
    if (!value) {
      setFilteredNominationsData(nominationsData);
    } else if (value.length > 4) {
      const filters = nominationsData.filter((item) => {
        return Object.keys(item).some((key) => {
          return (
            key != "_id" &&
            key != "key" &&
            typeof item[key] === "string" &&
            item[key] &&
            item[key].toLowerCase().includes(value)
          );
        });
      });
      setFilteredNominationsData([...filters]);
    }
  };
  const getQueryAndSetFilter = () => {
    const params = new URLSearchParams(search);

    var obj = {};
    for (const [key, val] of params.entries()) {
      if (
        key == "hotel" ||
        key == "category" ||
        key == "firstName" ||
        key == "score" ||
        key == "judge" ||
        key == "term"
      ) {
        if (obj[key]) {
          obj[key].push(val);
        } else {
          obj[key] = [val.split(",")];
        }
      } else if (key == "current") {
        obj[key] = parseInt(val);
      } else {
        obj[key] = val;
      }
    }

    if (obj) {
      setFilter(obj);
      setSortedInfo(obj);
    }
  };
  const onSearch = (value) => {
    const nextSearch = value.toLowerCase();
    setSearchText(nextSearch);
    if (!nextSearch) {
      setFilteredNominationsData(nominationsData);
    } else if (nextSearch.length > 2) {
      const filters = nominationsData.filter((item) => {
        return Object.keys(item).some((key) => {
          return (
            key != "_id" &&
            key != "key" &&
            typeof item[key] === "string" &&
            item[key] &&
            item[key].toLowerCase().includes(nextSearch)
          );
        });
      });
      setFilteredNominationsData([...filters]);
    }
  };
  const clearFilters = () => {
    setFilter({});
    setSortedInfo({});
    setSearchText("");
    setSearch("");
    setFilteredNominationsData(nominationsData);
  };
  const handleChange = (nextPagination, filters, sorter) => {
    console.log("Various parameters", sorter);
    const nextSorter = { ...sorter };
    delete nextSorter.column;
    setPagination(nextPagination);
    setSortedInfo(nextSorter);
    setFilter(filters);
    var cookieValue = {
      filteredInfo: filters,
      sortedInfo: nextSorter,
      pagination: nextPagination,
    };
    setCookie("haBasAdminDashboard", cookieValue, {
      path: "/admin",
    });
    // var newFilters = Object.assign({}, filteredInfo);
    // var newSolters = Object.assign({}, sortedInfo);
    // console.log(sorter);
    // if (sorter.column) {
    //   for (const [key, val] of Object.entries(sorter)) {
    //     if (Array.isArray(newSolters["columnKey"])) {
    //       if (!newSolters["columnKey"].includes(sorter["columnKey"])) {
    //         newSolters["columnKey"].push(sorter["columnKey"]);
    //       }
    //     } else {
    //       newSolters["columnKey"] = [sorter["columnKey"]];
    //     }
    //   }
    // }

    // if (
    //   filters.hotel ||
    //   filters.category ||
    //   filters.firstName ||
    //   filters.score ||
    //   filters.judge ||
    //   filters.term
    // ) {
    //   for (const [key, val] of Object.entries(filters)) {
    //     if (val) {
    //       newFilters[key] = val;
    //     }
    //   }
    // }

    // if (pagination) {
    //   newFilters["current"] = pagination.current;
    // }
    // console.log(newFilters);
    // // const url = new URL(window.location);
    // // url.searchParams.set("tab", newFilters);
    // // window.history.pushState({}, "", url);
    // setFilter(newFilters);
    // setSortedInfo(newFilters);
    // //convert object to query string
    // var queryString = Object.keys(newFilters)
    //   .map((key) => {
    //     if (Array.isArray(newFilters[key])) {
    //       return newFilters[key].map((item) => `${key}=${item}`).join("&");
    //       //else if it's an object
    //     } else if (typeof newFilters[key] === "object") {
    //       return;
    //     } else {
    //       return `${key}=${newFilters[key]}`;
    //     }
    //   })
    //   .join("&");

    // var pageUrl = "?" + queryString;
    // window.history.replaceState("", "", pageUrl);
    // setSearch(newFilters);
  };
  const checkIfAnswerClean = (record) => {
    if (typeof record.answerContainsNomineeOrHotel === "boolean") {
      return record.answerContainsNomineeOrHotel;
    }
    if (!record.hotel || !record.hotel.name) {
      return false;
    }
    const hotelName = record.hotel.name.split(" ");

    const questions = ["q1", "q2", "q3", "q4"];
    var contains = false;

    for (const question of questions) {
      if (!record[question].answer) {
        continue;
      }
      var containsHotelName = hotelName.some((item) =>
        record[question].answer.includes(item),
      );
      contains =
        record[question].answer.includes(record.firstName) ||
        record[question].answer.includes(record.firstName) ||
        containsHotelName;
    }

    return contains;
  };

  const getTotal = (record) => {
    if (record && record.score !== undefined) {
      return Math.floor((parseFloat(record.score) || 0) * 10) / 10;
    }
    var total = 0;
    for (const q of ["q1", "q2", "q3", "q4"]) {
      if (record[q] && record[q].score) {
        total += parseFloat(record[q].score);
      }
    }

    return Math.floor(total * 10) / 10;
  };
  const groupByCategory = (arr) => {
    var result = arr.reduce(function (r, a) {
      a.category = a.category || "No Category";
      r[a.category] = r[a.category] || [];
      r[a.category].push(a);
      return r;
    }, []);

    return result;
  };

  const getTopTenByCateogry = (nominationsData) => {
    var categorisedNominations = groupByCategory(nominationsData);
    var obj = {};
    for (const item of categories) {
      var categoryNomination = categorisedNominations[item];
      var result = categoryNomination.reduce((total, current) => {
        total.push(getTotal(current));

        return total;
      }, []);

      // get the top 10 number, if there are numbers less than 10, get the last number, if there are even numbers, set the next number as the top 10 number
      if (result.length < 10) {
        obj[item] = result.sort((a, b) => b - a)[result.length - 1];
      }

      obj[item] = result.sort((a, b) => b - a)[9];
    }

    return obj;
  };

  const columns = [
    // {
    //   title: "Term",
    //   dataIndex: "term",
    //   key: "term",
    //   filters: [
    //     {
    //       text: moment().year(),
    //       value: moment().year(),
    //     },
    //     {
    //       text: moment().year() - 1,
    //       value: moment().year() - 1,
    //     },
    //   ],
    //   defaultFilteredValue: [2023],
    //   filteredValue: filteredInfo.term,
    //   onFilter: (value, record) => {
    //     return record && record.term == value;
    //   },
    //   render: (text, record) => {
    //     return <>{record.term}</>;
    //   },
    // },
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",

      render: (text, record) => (
        <Link
          to={`/admin/nominations/${record._id}`}
          state={{
            nominations: filteredNominationsData.map((item) => item._id),
            nominationNavigation: {
              filters: filteredInfo,
              sorter: sortedInfo,
              search: searchText,
            },
          }}
        >
          {record.firstName}
        </Link>
      ),

      filteredValue: filteredInfo.firstName || null,
      filters: [{ text: "Contained", value: 0 }],
      onFilter: (value, record) => {
        return checkIfAnswerClean(record);
      },
      sorter: (a, b) => a.firstName.localeCompare(b.firstName),
      sortOrder: sortedInfo.columnKey === "firstName" && sortedInfo.order,
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
      sorter: (a, b) => a.lastName.localeCompare(b.lastName),
      sortOrder: sortedInfo.columnKey === "lastName" && sortedInfo.order,
      render: (text, record) => (
        <Link
          to={"/admin/nominations/" + record._id}
          state={{
            nominations: filteredNominationsData.map((item) => item._id),
            nominationNavigation: {
              filters: filteredInfo,
              sorter: sortedInfo,
              search: searchText,
            },
          }}
        >
          {text}
        </Link>
      ),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a.title.localeCompare(b.title),
      sortOrder: sortedInfo.columnKey === "title" && sortedInfo.order,
    },
    {
      title: "Hotel",
      dataIndex: "hotel",
      key: "hotel",
      filteredValue: filteredInfo.hotel || null,

      sortOrder: sortedInfo.columnKey === "hotel" && sortedInfo.order,
      filters: [
        ...[...hotels].sort(compareHotelNames).map((hotel) => {
          return {
            text: hotel.name,
            value: hotel._id,
          };
        }),
      ],
      filterSearch: true,
      sorter: (a, b) => {
        return compareHotelNames(a, b);
      },
      onFilter: (value, record) => {
        if (value == "00000") {
          return !record.hotel;
        }
        if (record.hotel) {
          return record.hotel._id == value;
        }
        return false;
      },
      render: (text, record) => {
        if (record.hotel) {
          return record.hotel.name;
        } else {
          return "";
        }
      },
      ellipsis: true,
    },
    {
      title: "Nominated By",
      dataIndex: "user",
      key: "user",
      sorter: (a, b) => {
        if (!a.user || !b.user) {
          return !a.user ? 1 : -1;
        }
        return a.user.lastName.localeCompare(b.user.lastName);
      },
      sortOrder: sortedInfo.columnKey === "user" && sortedInfo.order,
      filters: [
        {
          text: "No nominator",
          value: 0,
        },
      ],
      onFilter: (value, record) => {
        if (value == 0) {
          return !record.user;
        }
        if (record.user) {
          return (
            record.user.firstName + " " + record.user.lastName == value ||
            record.user.email == value
          );
        }
        return false;
      },
      filteredValue: filteredInfo.user || null,
      filterSearch: true,
      render: (text, record) => {
        if (record.user) {
          return (
            <Text>
              {record.user.firstName + " " + record.user.lastName}
              <br />
              <small>{record.user.email}</small>
            </Text>
          );
        }
      },
    },
    {
      title: "Category",
      key: "category",
      dataIndex: "category",
      filteredValue: filteredInfo.category || null,
      sortOrder: sortedInfo.columnKey === "category" && sortedInfo.order,
      filters: categories.map((item) => {
        return { text: item, value: item };
      }),
      onFilter: (value, record) => record.category == value,
      ellipsis: true,
      sorter: (a, b) => a.category.localeCompare(b.category),
      render: (tag, record) => {
        const colors = ["volcano", "darkSalmon", "geekblue", "green"];
        const colorIndex = categories.findIndex((item) => item == tag);

        let color = colors[colorIndex];

        return (
          <Tag color={color} key={record._id}>
            {tag.toUpperCase()}
          </Tag>
        );
      },
    },
    {
      title: "Judge",
      key: "judge",
      filterSearch: true,
      sorter: (a, b) => {
        if (!a.judge || !b.judge) {
          return !a.judge ? 1 : -1;
        }
        return a.judge.lastName.localeCompare(b.judge.lastName);
      },
      filteredValue: filteredInfo.judge || null,
      filters: groupByJudge(nominationsData).map((item) => {
        return {
          text: item.firstName + " " + item.lastName,
          value: item._id,
        };
      }),
      onFilter: (value, record) => {
        if (value == 0) {
          return !record.judge;
        }
        if (record.judge) {
          return record.judge._id == value;
        }
        return false;
      },
      render: (text, record) => {
        if (record.judge) {
          var judgeHotels = [];
          var judgeHotel;
          if (record.judge.hotels) {
            judgeHotels = record.judge.hotels;
            if (!record.judge.hotels.includes(record.judge.hotel)) {
              judgeHotels.push(record.judge.hotel);
            }
          } else if (record.judge.hotel) {
            judgeHotels.push(record.judge.hotel);
          }
          if (judgeHotels.length > 0) {
            judgeHotel = judgeHotels.map((item) => {
              var matchedHotel = hotels.find((hotel) => hotel._id == item);
              if (matchedHotel) {
                return (
                  <small key={matchedHotel._id}>{matchedHotel.name}</small>
                );
              }
            });
          }

          return (
            <>
              <Text>
                {record.judge.firstName + " " + record.judge.lastName}
              </Text>
              <br />
              <Text>{judgeHotel}</Text>
            </>
          );
        } else {
          return "Un-assigned";
        }
      },
    },
    {
      title: "Score",
      key: "score",
      sortOrder: sortedInfo.columnKey === "score" && sortedInfo.order,
      sorter: (a, b) => {
        return getTotal(a) - getTotal(b);
      },
      filteredValue: filteredInfo.score || null,
      filters: [
        { text: "Un-scored", value: 0 },
        { text: "Top 10", value: 1 },
      ],
      onFilter: (value, record) => {
        if (value == 0) {
          return getTotal(record) == 0;
        }

        if (value == 1) {
          var standardsByCategory = getTopTenByCateogry(nominationsData);
          return (
            getTotal(record) >= standardsByCategory[record.category] &&
            record.excludedFromFinal != true
          );
        }
        return false;
      },
      render: (text, record) => {
        var total = getTotal(record);
        return <>{String(total)}</>;
      },
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        return (
          <Space size="middle">
            {record.excludedFromFinal ? (
              <Tag>Excluded </Tag>
            ) : (
              <Button
                onClick={async () => {
                  setLoading(true);
                  const response = await Axios.post(
                    apiRoutes[environment].adminUpdateNomination,
                    {
                      _id: record._id,
                      excludedFromFinal: true,
                    },
                  );

                  if (response.status == 200) {
                  }
                  setLoading(false);
                }}
              >
                Exclude From finalList
              </Button>
            )}

            <Link
              to={`/admin/nomination/${record._id}/edit`}
              state={{
                nominations: filteredNominationsData.map((item) => item._id),
                nominationNavigation: {
                  filters: filteredInfo,
                  sorter: sortedInfo,
                  search: searchText,
                },
              }}
            >
              Edit
            </Link>
            <Popconfirm
              title="Are you sure to delete this nomination?"
              onConfirm={() => deleteNomination(record._id)}
              okText="Yes"
              cancelText="No"
            >
              <a>Delete</a>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  const nominationDatatoDownload = () => {
    const data = [];
    for (const item of nominationsData) {
      var obj = {};
      obj["Category"] = item.category;
      obj["First Name"] = item.firstName;
      obj["Last Name"] = item.lastName;
      obj["Title"] = item.title;
      obj["Hotel"] = item.hotel ? item.hotel.name : "N/A";
      obj["Nominated By"] =
        item.user && item.user.firstName
          ? item.user.firstName + " " + item.user.lastName
          : "N/A";
      obj["Nominor Email"] = item.user && item.user.email;
      data.push(obj);
    }

    return data;
  };
  return (
    <Spin spinning={loading}>
      <Paragraph>Total Nominations: {nominationsData.length}</Paragraph>
      <Search
        style={{ width: "50%" }}
        placeholder="Search ..."
        onSearch={onSearch}
        enterButton
        onChange={onChange}
      />
      <Button onClick={clearFilters}>Clear filters</Button>
      <Divider />
      <Button>
        <CSVLink
          filename={`nominations_${moment().format("YYYY_MM_DD")}.csv`}
          target="_blank"
          data={nominationDatatoDownload()}
        >
          Download me
        </CSVLink>
      </Button>
      <Table
        scroll={{
          x: 600,
        }}
        columns={columns}
        dataSource={filteredNominationsData}
        onChange={handleChange}
        pagination={{
          pageSize: pagination.pageSize || 10,
          current: pagination.current || 1,
          showSizeChanger: true,
        }}
      />
    </Spin>
  );
}
